import request from '@/utils/request'

const BaseUrl = '/resourceRorrowing'

// 资源借用新增
export function addUse(data) {
  return request({
    url: `${BaseUrl}/save`,
    method: 'post',
    data
  })
}

// 资源借用修改
export function updateUse(data) {
  return request({
    url: `${BaseUrl}/update`,
    method: 'put',
    data
  })
}

// 资源借用删除
export function deleteUseById(id) {
  return request({
    url: `${BaseUrl}/delete/${id}`,
    method: 'delete',
  })
}

// 资源借用详情
export function useDetails(id) {
  return request({
    url: `${BaseUrl}/${id}`,
    method: 'get',
  })
}

// 资源借用审核
export function review(data) {
  return request({
    url: `${BaseUrl}/reviewResourceRorrowing`,
    method: 'post',
    data
  })
}

// /resourceApply/getSkillRank
export function getSkillRank(params) {
  return request({
    url: '/resourceApply/getSkillRank',
    method: 'get',
    params
  })
}

// /resourceRorrowing/getOriginalProject
export function getOriginalProject(params) {
  return request({
    url: `${BaseUrl}/getOriginalProject`,
    method: 'get',
    params
  })
}

